import { useState } from "react";
import { toast } from "sonner";
import { PhoneCall, Loader2 } from "lucide-react";
import plannerApi from "@/lib/plannerApi";

export const CallbackCard = ({ plannerType = "" }) => {
    const [f, setF] = useState({ name: "", phone: "", note: "" });
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const send = async () => {
        setBusy(true);
        try {
            await plannerApi.post("/callback", { ...f, planner_type: plannerType });
            setDone(true);
        } catch (e) { toast.error(e.response?.data?.detail || "Couldn't send request"); }
        finally { setBusy(false); }
    };
    return (
        <div className="rounded-2xl bg-white border border-slate-200 p-5" data-testid="planner-callback-card">
            <div className="flex items-center gap-2 font-black text-slate-900">
                <PhoneCall size={16} className="text-emerald-700"/> Need help building your list?
            </div>
            {done ? (
                <p className="text-sm text-emerald-700 mt-2" data-testid="planner-callback-done">Thanks — our team will call you back.</p>
            ) : (
                <div className="mt-3 grid sm:grid-cols-[1fr_1fr_auto] gap-2">
                    <input className="hdb-input" placeholder="Your name" value={f.name}
                           onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="planner-callback-name"/>
                    <input className="hdb-input" placeholder="10-digit mobile" inputMode="numeric" value={f.phone}
                           onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="planner-callback-phone"/>
                    <button onClick={send} disabled={busy} data-testid="planner-callback-submit"
                            className="px-4 py-2 rounded-lg bg-emerald-600 text-white font-bold text-sm hover:bg-emerald-500 inline-flex items-center gap-1.5 justify-center">
                        {busy && <Loader2 size={13} className="animate-spin"/>} Request a call
                    </button>
                </div>
            )}
        </div>
    );
};
